import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-schemes-delete',
	path: '/secure/admin/DeletePermissionScheme!default.jspa',
};
